// extracted by mini-css-extract-plugin
export default {"imageView":"image-view_imageView__HUOZt","descriptionText":"image-view_descriptionText__egxwo","editable":"image-view_editable__xhYwR"};